import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AdditionalInfo from '../../ProgressNote/AdditionalInfo'
import { saveEncounterField } from '../../../../redux/sidePanel/sidePanelThunk'
import { debouncer } from './sharedPanelComponents/sharedAIfunctions'
import { setEncounterField } from '../../../../redux/sidePanel/sidePanelSlice'
import AdditionalAttachments from '../../../../components/NewEncounter/AdditionalAttachmentEncounter/AdditionalAttachments'

function calculateBillingEntity(legal_entity_id, legalEntities) {
  return legal_entity_id ? { legal_entity_id: legal_entity_id } : legalEntities?.[0]
}
export default function PanelOtherCard() {
  const dispatch = useDispatch()
  const provider = useSelector((state) => state?.user?.provider)
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)

  const isReadOnly = useSelector((state) => state.sidePanel.isReadOnly)
  const isLastEncounter = useSelector((state) => state.sidePanel.isLastEncounter)

  const chargeId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)
  const telehealth = useSelector((state) => state.sidePanel.panelEncounter?.telehealth)
  const hospice_related = useSelector((state) => state.sidePanel.panelEncounter?.hospice_related)
  const care_coordination = useSelector(
    (state) => state.sidePanel.panelEncounter?.care_coordination,
  )
  const careTeam = useSelector((state) => state.sidePanel.panelEncounter?.careteam)
  const neuroSuite = useSelector((state) => state.sidePanel.panelEncounter?.neuro_suite)
  const pending_cosign = useSelector((state) => state.sidePanel.panelEncounter?.pending_cosign)
  const authNumber = useSelector((state) => state.sidePanel.panelEncounter?.auth_number)
  const billingNotes = useSelector(
    (state) => state.sidePanel.panelEncounter?.code_assist?.billing_notes,
  )
  const legal_entity_id = useSelector((state) => state.sidePanel.panelEncounter?.legal_entity_id)

  const [billingNoteState, setBillingNotes] = useState(billingNotes)

  const updateEncounter = async (value, field, grouping) => {
    await dispatch(
      setEncounterField({
        field,
        value,
        ...(grouping && { grouping }),
      }),
    )
    debouncer(() => dispatch(saveEncounterField({})))
  }

  return (
    <div id={'PanelOtherCard'}>
      <div style={{ position: 'relative' }}>
        {isReadOnly && <div className={'locked'}></div>}
        <AdditionalInfo
          visit={panelEncounter}
          billingTxt={billingNoteState}
          setBillingTxt={(newBillTxt) => {
            setBillingNotes(newBillTxt)
            debouncer(() => updateEncounter(newBillTxt, 'billing_notes', 'code_assist'))
          }}
          selectedSharedProvider={panelEncounter?.incident_to_provider_id}
          setSelectedSharedProvider={(newSSP) => {
            updateEncounter(newSSP, 'incident_to_provider_id')
          }}
          incidentToProviderSubstantive={panelEncounter?.incident_to_provider_substantive}
          setIncidentToProviderSubstantive={(isSubstantive) => {
            updateEncounter(isSubstantive, 'incident_to_provider_substantive')
          }}
          isTeleHealth={Boolean(telehealth)}
          setIsTeleHealth={(newTelehealth) => {
            updateEncounter(newTelehealth, 'telehealth')
          }}
          isHospiceRelated={Boolean(hospice_related)}
          setIsHospiceRelated={(newHospiceRelated) => {
            updateEncounter(newHospiceRelated, 'hospice_related')
          }}
          isCareCoordination={Boolean(care_coordination)}
          setIsCareCoordination={(newCareCoord) => {
            updateEncounter(newCareCoord, 'care_coordination')
          }}
          setBillingEntity={(newBE) => {
            updateEncounter(newBE?.legal_entity_id || newBE.value, 'legal_entity_id')
          }}
          billingEntity={calculateBillingEntity(
            legal_entity_id || panelEncounter.legal_entity_id,
            provider?.legal_entities,
          )}
          billingEntityOptions={provider?.legal_entities || []}
          showCareTeam={false}
          careTeam={careTeam}
          setCareTeam={(newCareTeam) => {
            updateEncounter(newCareTeam, 'careteam')
          }}
          isNeuroSuite={isLastEncounter ? false : neuroSuite}
          setIsNeuroSuite={(newNeuroSuite) => {
            updateEncounter(newNeuroSuite, 'neuro_suite')
          }}
          isPendingCosign={isLastEncounter ? false : pending_cosign}
          setIsPendingCosign={(newPendCosign) => {
            updateEncounter(newPendCosign, 'pending_cosign')
          }}
          authNumber={authNumber}
          setAuthNumber={(newAuthNum) => {
            updateEncounter(newAuthNum, 'auth_number')
          }}
        />
      </div>
      <AdditionalAttachments chargeId={chargeId} patientId={patientId} />
    </div>
  )
}
